import 'styled-components/macro';
import React from 'react';
import { Typography, useTheme } from '@harver/shared-ui';
import { EmailOutlinedIcon } from '@harver/shared-ui/lib/icons';

import { ContentCard } from '../../../components/ContentCard';
import { useContent } from '../../../branding/content.context';
import CookieBanner from '../../../components/CookieBanner';

export function OpenInviteAlreadyRegistered() {
    const theme = useTheme();
    const { openInviteEmailUnique: template } = useContent();
    document.title = template.browserTitle;
    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <EmailOutlinedIcon
                        css={{
                            fontSize: '4.5rem',
                            color: '#424242',
                            marginBottom: theme.sizes.medium,
                        }}
                    />

                    <Typography
                        testId="openinvite.alreadyregistered"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                            color: '#192A2D',
                        }}
                        variant="h2"
                    >
                        {template.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                            color: '#192A2D',
                            fontWeight: '500',
                            fontSize: '15px',
                            lineHeight: '24px',
                        }}
                        variant="body2"
                    >
                        {template.p1}
                    </Typography>
                </div>
                <CookieBanner />
            </ContentCard>
        </>
    );
}
